export default __webpack_public_path__ + "static/media/skopai.9f9f13b5.png";